import {debug} from "../js/lib/common";
import {subscribeToUserRole} from "../js/channels/user_role";

debug("application.js");

const { id, dataset } = document.body;
const { flashNotice, flashError, currentUserId } = dataset;

if (currentUserId) {
  subscribeToUserRole((data) => {
    window.dispatchEvent(new CustomEvent("user:role-changed", { detail: data }));
  });
}

debug("ID", id);
switch (id) {
  case "home-index":
    import("../js/views/admin/index");
    break;
  case "equipment_assessments-index":
    import("../js/views/assessment/index");
    break;
  case "home-dashboard":
    import("../js/views/dashboard/index");
    break;
  case "devise-sessions-new":
    import("../js/views/devise/sessions/new");
    break;
  case "home-mobile":
    import("../js/views/mobile/index");
    break;
  case "reports-show":
    import("../js/views/reports/index");
    break;
  case "home-yoy_dashboard":
    import("../js/views/yoy_dashboard/index");
    break;
  case "wifi_assessment-index":
    import("../js/views/wifi_assessments/index");
    break;
}

// Setup header
const profileMenuLink = document.getElementById("profile-menu-link");
const profileDropdown = document.getElementById("profile-dropdown");

if (profileMenuLink && profileDropdown) {
  profileMenuLink.addEventListener("click", (e) => {
    // e.preventDefault();
    profileDropdown.classList.toggle("show");
  });
  window.addEventListener('click', function(e){
    if (!profileMenuLink.contains(e.target) && (!profileDropdown.contains(e.target))){
      profileDropdown.classList.remove("show");
    }
  })
}
